import React, { Component } from 'react';
import { Button } from 'reactstrap'

class NormalButton extends Component {

  constructor(props) {
    super(props);
  }

  render() {

    let cloneProps = Object.assign({}, this.props);
    {
      let className = cloneProps.className || "";
      className = className + " mini-button btn-icon";
      cloneProps.className = className;
    }
    {
      if (!cloneProps.style)
        cloneProps.style = {};
      cloneProps.style.position = "relative";
      cloneProps.style.fontSize = "0.8571em";
    }


    if (cloneProps.title) {
      cloneProps.toggle = "tooltip";
      cloneProps.placement = "bottom";
      cloneProps.rel = "tooltip";
    }

    delete cloneProps.faIcon;

    let innerClassName = "";
    if (this.props.faIcon) {
      innerClassName = innerClassName + " fa ";
      innerClassName = innerClassName + this.props.faIcon;
    }

    if (!cloneProps.size)
      cloneProps.size = "sm";

    return <Button {...cloneProps}>
      {this.props.children}
      <i className={innerClassName} style={{left: "unset", right: "-2px"}}/>
    </Button>
  }
}

export default NormalButton;
